module.exports = __webpack_public_path__ + "img/4-2-1-5-3-preview-happysaea-e.92b22b61.jpg";